import React, { useState } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import InventoryCarCard from "../inventory-car-card";
import Slider from "react-slick";
import OurLocationModal from "../our-location-modal";
import H2Blue from "../../shared/h2-bule/component";
import TrackImpression from "../../shared/track-impression";
import { trackDesktopCustomEventsAU } from "../../../tracking";

const MoreCarsRevamp = ({title, carList = [], config, isMoreCars, sourceAppointmentId}) => {
    const [showLocationModal, setShowLocationModal] = useState(false);

    const settings = {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrow: true,
        dots: false,
        infinite: false,
        afterChange: () => {}
    };

    const impressionAction = isMoreCars ? "Similar Cars Impression" : "More cars Impression";
    const clickAction = isMoreCars ? "Similar Cars Click" : "More cars Click";

    const handleCardClick = (item) => {
        if (sourceAppointmentId) {
            trackDesktopCustomEventsAU(clickAction, {
                event: "custom_event",
                eventCategory: "cars24_detail_page",
                eventAction: clickAction,
                eventLabel: `${sourceAppointmentId} | ${item.appointmentId}`
            });
        }
    };

    return (
        <React.Fragment>
            <div styleName={"styles.sliderWrapper"}>
                <H2Blue text={title} fontWeight="700" />
                <Slider {...settings}>
                    {carList.map((item, index) => (
                        <TrackImpression
                            key={index}
                            event={sourceAppointmentId ? {
                                name: impressionAction,
                                data: {
                                    event: "custom_event",
                                    eventCategory: "cars24_detail_page",
                                    eventAction: impressionAction,
                                    eventLabel: `${sourceAppointmentId} | ${item.appointmentId}`
                                }
                            } : {}}
                            wrapWithDiv={false}
                        >
                            <InventoryCarCard
                                onClickCallback={() => handleCardClick(item)}
                                config={config}
                                gtmFrom="home_page"
                                defaultTootlipStyle="styles.top"
                                index={index}
                                item={item}
                                egcRenderType="details"
                                bodyType={item.body || item.bodyType}
                                showLocationCallback={() => setShowLocationModal(true)}
                                ampProperty={{"cdp source": isMoreCars ? "similar car" : "more models"}}
                                isSourceSimilarCars={true}
                                {...({...item, emiDetails: item.emiDetails || {}}) } />
                        </TrackImpression>
                    ))}
                </Slider>
                {showLocationModal && <OurLocationModal handleModalClose={() => setShowLocationModal(false)} />}
            </div>
        </React.Fragment>
    );
};

MoreCarsRevamp.propTypes = {
    title: PropTypes.string,
    carList: PropTypes.array,
    config: PropTypes.object,
    isMoreCars: PropTypes.bool,
    isCdpRevamp: PropTypes.bool,
    sourceAppointmentId: PropTypes.string
};

export default MoreCarsRevamp;
